import React from 'react';
import clsx from 'clsx';

import { Color } from 'types/colors';

import css from './Typography.module.scss';

export type TextStyle =
    | 'BodyExtraSmallNormal'
    | 'BodyExtraSmallBold'
    | 'BodySmallNormal'
    | 'BodySmallSemibold'
    | 'BodyMedSmallNormal'
    | 'BodyMedSmallSemibold'
    | 'BodyMedNormal'
    | 'BodyMedSemibold'
    | 'BodyLargeNormal'
    | 'BodyLargeSemibold'
    | 'HeadMedSemibold'
    | 'HeadLargeNormal'
    | 'HeadMedLargeMedium'
    | 'HeadLargeBold'
    | 'ButtonMedSemibold'
    | 'ButtonLargeSemibold'
    | 'BadgeBold';

export interface TypographyProps extends React.PropsWithChildren {
    // These are Figma style names — there should generally always be a style name,
    style?: TextStyle;

    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' | 'div';
    align?: 'center' | 'justify' | 'left' | 'right' | 'inherit';
    color?: Color | 'inherit';
    ellipsis?: boolean;
    className?: string;
    onClick?: () => void;
}

const Typography: React.FC<TypographyProps> = ({
    tag = 'p',
    align = 'left',
    color = 'gray',
    ellipsis = false,
    style = 'BodyMedNormal',
    className,
    children,
    onClick,
}) => {
    const Tag = tag;
    const rootVars = getComputedStyle(document.body);

    const classNames = clsx(
        css.typography,
        align && css[`align_${align}`],
        ellipsis && css.ellipsis,
        css[`figma_${style}`],
        className,
    );

    return (
        <Tag
            className={classNames}
            style={{ color: color ? rootVars.getPropertyValue(`--${color}`) : 'inherit' }}
            onClick={onClick}
        >
            {children}
        </Tag>
    );
};

export default React.memo(Typography);
